import React from "react";
import { connect } from "react-redux";
import { useDragLayer } from "react-dnd";
import { snapToGrid } from "./snapToGrid";
import { GanttWorkOrder } from "../gantt/ganttItem";
import * as DndConstants from "./dndConstants";

const layerStyles = {
    position: "fixed",
    pointerEvents: "none",
    zIndex: 100,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
};

function getItemStyles(initialClientOffset, initialOffset, currentOffset, currentScroll, isSnapToGrid, width) {
    if (!initialOffset || !currentOffset) {
        return {
            display: "none",
        };
    }
    const dx = initialClientOffset.x - initialOffset.x - width / 2;
    const dy = initialClientOffset.y - initialOffset.y - DndConstants.DRAG_OFFSET_Y;
    let { x, y } = currentOffset;
    if (currentScroll) {
        x += currentScroll.scrollLeft; // For DnD after scrolling horizontally in table
    }
    x += dx;
    y += dy;
    if (isSnapToGrid) {
        x -= initialOffset.x;
        y -= initialOffset.y;
        [x, y] = snapToGrid(x, y);
        x += initialOffset.x;
        y += initialOffset.y;
    }
    const transform = `translate(${x}px, ${y}px)`;
    return {
        transform,
        WebkitTransform: transform,
    };
}

const calcWorkOrderWidth = (timeRange, ganttWidth, item) => {
    const ratio = (timeRange.end - timeRange.start) / ganttWidth;
    const width = item.duration / ratio;
    return width;
};

export const TaskRowDragLayer = (props) => {
    const { itemType, isDragging, item, initialClientOffset, initialOffset, currentOffset } = useDragLayer((monitor, props) => ({
        props: props,
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        initialClientOffset: monitor.getInitialClientOffset(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging(),
    }));

    function renderItem(width) {
        switch (itemType) {
            case DndConstants.ItemTypes.TASK:
                return (
                    <div
                        className="rct-item work-order"
                        style={{
                            fontSize: "12px",
                            color: "white",
                            cursor: "move",
                            background: "rgb(255, 193, 7)",
                            border: "1px solid rgb(255, 152, 0)",
                            boxSizing: "border-box",
                            width: width + "px",
                            height: DndConstants.DRAG_HEIGHT + "px",
                            lineHeight: DndConstants.DRAG_HEIGHT + "px",
                        }}>
                        <GanttWorkOrder
                            item={{
                                workOrderNumber: item.id,
                            }}
                            itemContext={{
                                dimensions: {
                                    height: DndConstants.DRAG_HEIGHT + "px",
                                },
                            }}
                        />
                    </div>
                );
            default:
                return null;
        }
    }

    if (!isDragging) {
        return null;
    }

    const width = calcWorkOrderWidth(props.timeRange, props.ganttWidth, item);

    return (
        <div style={layerStyles}>
            <div style={getItemStyles(initialClientOffset, initialOffset, currentOffset, props.currentScroll, props.snapToGrid, width)}>
                {renderItem(width)}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    timeRange: state.domain.timeRange,
    ganttWidth: state.gantt.width,
});

export default connect(mapStateToProps)(TaskRowDragLayer);
